module.exports = __webpack_public_path__ + "static/media/hyperloop.2607beea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/hyperloop.jpg
// module id = 349
// module chunks = 0